<template>
<div>
  <link href="https://use.fontawesome.com/releases/v5.0.13/css/all.css" rel="stylesheet">
  <!-- <v-btn
    id="btn"
    persistent
    color="success"
    dark
    v-on="on"
    @click="addNodes()"
  >
    Add Test
  </v-btn> -->
  <v-dialog v-model="dialogAdd" persistent max-width="600px" class="v-dialog-edit">
      <template v-slot:activator="{}">
        <!-- <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn> -->
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Detail Employee</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="d-flex" cols="10" v-if="chkAddTitle === false">
                <v-select
                  :items="items"
                  label="Title"
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="10" v-if="chkAddTitle === true">
                <v-text-field
                  label="New Title"
                  persistent-hint
                  required
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="chkAddTitle === false">
                <v-btn color="success" fab small dark>
                  <v-icon @click="switchAddTitle(true)">mdi-plus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="2" v-if="chkAddTitle === true">
                <v-btn color="warning" fab small dark>
                  <v-icon @click="switchAddTitle(false)">mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="10">
                <v-text-field
                label="ค้นหา Employee"
                placeholder="ID, Frist Name, Last Name"
                outlined
              ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn color="success" fab small dark>
                  <v-icon>mdi-pencil</v-icon>
                  <!-- <v-icon>fas fa-search</v-icon> -->
                </v-btn>
              </v-col>
              <v-col cols="10">
                <v-text-field
                  label="Frist name*"
                  persistent-hint
                  required
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="10">
                <v-text-field
                  label="Last name*"
                  persistent-hint
                  required
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogAdd = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="dialogAdd = false">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-dialog v-model="dialog" persistent max-width="600px" class="v-dialog-edit">
    <template v-slot:activator="{ on, attrs }">
      <div id="createShow" style="background-color: ">
        <v-layout class="row">
          <v-col class="text-center" cols="12" style="margin-top: 5%">
            <v-btn class="ma-2" tile color="success" large dark v-bind="attrs" v-on="on" :disabled="companyNameReq !== ''">
              <v-icon left>mdi-pencil</v-icon> Create Chart
            </v-btn>
          </v-col>
        </v-layout>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Create Company</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Company Name*" v-model="companyName" required></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="addCom(companyName)">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>
<script>
import swal from 'sweetalert'

export default {
  name: 'tree',
  data () {
    return {
      tab: null,
      dialog: false,
      dialogAdd: false,
      chkAddTitle: false,
      companyName: '',
      companyNameReq: '',
      companyDetail: '',
      chart: '',
      newNodes: '',
      editForm: '',
      nameInput: '',
      titleInput: '',
      cancelButton: '',
      saveButton: '',
      nodeId: '',
      items: [
        'Profile', 'Org Chart'
      ],
      text: 'Lorem ipsum dolor sit amet',
      mockups: [
        {
          id: 1,
          name: 'คณะกรรมการบริษัท'
        }
      ]
    }
  },
  created () {
    // this.oc(this.$refs.tree, this.mockups)
  },
  methods: {
    async addCom (companyName) {
      // console.log('Company Name', this.companyName)
      this.companyName = companyName
      this.companyNameReq = companyName
      this.dialog = false
      if (this.companyName !== '') {
        // console.log('If', this.companyName)
        this.oc(this.$refs.tree, this.mockups)
        document.getElementById('orgShow').style.display = 'block'
        document.getElementById('createShow').style.display = 'none'

        this.chart.load([
          { id: 1, name: `${this.companyName}`, title: 'CEO', img: 'https://cdn.balkan.app/shared/11.jpg' }
        ])
      } else if (this.companyName === '') {
        // console.log('Else', this.companyName)
        document.getElementById('orgShow').style.display = 'none'
        document.getElementById('createShow').style.display = 'block'
      }
      // this.chart.draw()
      // await this.axios({
      //   method: 'post',
      //   url: 'http://localhost:3001/api/v1/companys',
      //   // url: 'http://localhost:3000/api/login/getTokenLogin',
      //   // url: 'http://localhost:3000/api/login/getTokenLogin',
      //   data: {
      //     companyName: this.companyName

      //   }
      // }).then(function (response) {
      //   console.log(response.data)
      //   Swal.fire({
      //     icon: 'success',
      //     title: 'Create Company Success'
      //   })
      // }).catch(function (err) {
      //   self.overlay = false
      //   console.log('err: ', err)
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Create Fail'
      //   })
      // })
    },
    async getTitle () {
      try {
        await this.axios({
          method: 'get',
          url: 'http://localhost:3001/api/v1/companys'
          // url: 'http://localhost:3000/api/login/getTokenLogin',
          // url: 'http://localhost:3000/api/login/getTokenLogin',
        }).then(function (response) {
          // console.log(response.data)
        })
      } catch (error) {
        swal('Error', 'Create fail', 'error')
      } finally {
        self.overlay = false
      }
    },
    addNodes (id, pid) {
      // console.log('EEEEEEEEEEEE', nodeId)
      // var that = this
      // var node = chart.get(nodeId)
      // console.log('Chart', this.chart)
      // console.log('PId Node', pid)
      // console.log('Id Node', id)
      this.dialogAdd = true
    },
    switchAddTitle (value) {
      if (this.chkAddTitle === false) {
        this.chkAddTitle = value
        this.$forceUpdate()
      } else if (this.chkAddTitle === true) {
        this.chkAddTitle = value
        this.$forceUpdate()
      }
      // console.log('Switch', this.chkAddTitle)
    }
  },
  watch: {
    companyName: function (val) {
    }
  },
  mounted () {
    document.getElementById('createShow').style.display = 'none'
    this.companyName = ''
    // document.getElementById('orgShow').style.display = 'block'
    // this.getEmitFullDialog(this.companyNameReq)
    // this.$emit('dialog', this.dialog)
  }
}
</script>

<style>
.v-dialog-edit {
  /* border-radius: 0 !important; */
}
.v-dialog {
  /* border-radius: 0 !important; */
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}
</style>
